
<div  class="val-fonte-icone val-flex-conteneur">
  <div class="val-flex-1"></div>
  <div class="val-flex-conteneur val-flex-colonne">
    <div class="val-flex-1"></div>
    @if (utiliserRotation)
    {
      <div  [class]="iconeCss"
            class="val-icone"
            [class.deg90]="rotation"
            [class.deg0]="!rotation">
      </div>
    }
    @else if (utiliserRotation180) 
    {
      <div  [class]="iconeCss"
            class="val-icone"
            [class.deg180]="rotation"
            [class.deg0]="!rotation">
      </div>
    }
    @else if (utiliserRotation270) 
    {
      <div  [class]="iconeCss"
            class="val-icone"
            [class.deg270]="rotation"
            [class.deg0]="!rotation">
      </div>
    }
    @else 
    {
      <div  [class]="iconeCss"
            class="val-icone">
      </div>
    }
    <div class="val-flex-1"></div>
  </div>
  <div class="val-flex-1"></div>
</div>


